module.exports = __webpack_public_path__ + "static/img/SK@2x.1a9d5fba.jpg";